<div
  [attr.id]="message.id"
  [class]="message.styleClass"
  [ngClass]="['z-toast-message-' + message.severity, 'z-toast-message']"
  [@messageState]="{
    value: 'visible',
    params: {
      showTransformParams: showTransformOptions,
      hideTransformParams: hideTransformOptions,
      showTransitionParams: showTransitionOptions,
      hideTransitionParams: hideTransitionOptions
    }
  }"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()"
>
  <div class="z-toast-message-content">
    <div class="flex flex-grow-1 surface-overlay border-1 surface-border surface-overlay">
      <div class="flex flex-grow-1 flex-column p-3">
        <div class="flex align-items-center">
          <span class="z-toast-message-icon">
            <i
              class="fa-light"
              [ngClass]="{
                'fa-circle-check': message.severity === 'success',
                'fa-circle-info': message.severity === 'info',
                'fa-triangle-exclamation': message.severity === 'warn',
                'fa-circle-xmark': message.severity === 'error'
              }"
            ></i>
          </span>
          <span class="font-medium text-2xl text-900 z-toast-title">{{ message.title }}</span>
        </div>
        <p class="my-3 p-0 line-height-3 text-700 z-toast-detail" [innerHtml]="message.message"></p>

        <div class="z-toast-progress" *ngIf="message.progressBar && !message.sticky && !!message.duration && message.duration >= 3000">
          <div [style]="{ animationDuration: message.duration + 'ms' }"></div>
        </div>
      </div>

      <div class="flex flex-column border-left-1 surface-border" *ngIf="message.closable !== false || !!message.action">
        <div
          *ngIf="message.closable !== false"
          class="z-toast-action flex-auto flex align-items-center justify-content-center px-3"
          (click)="onCloseClick($event)"
          (keydown.enter)="onCloseClick($event)"
        >
          <span>{{ message.closeLabel }}</span>
        </div>

        <div
          *ngIf="!!message.action"
          class="z-toast-action flex-auto border-top-1 surface-border flex align-items-center justify-content-center px-3"
          (click)="onActionClick($event)"
          (keydown.enter)="onActionClick($event)"
        >
          <span>{{ message.actionLabel }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
